<template>
<!-- eslint-disable max-len -->
<list-page
  name="Endgame Settings"
  plural="Endgame Settings"
  use="_id"
  :display="display"
  page-prefix="/blade/outros"
  :fetch="getOutros"
  :remove="deleteOutro"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  methods: {
    ...mapActions([
      'getOutros',
      'deleteOutro',
    ]),
    display({ name: outroName, updated }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      return `${outroName} ${dateString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/OutrosList.vue